import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { Link, withRouter } from 'react-router';
import { contains } from 'ramda';
import moment from 'moment';

// Redux
import { connect } from 'react-redux';
import { verifyDob } from '../../../actions/session/sessionActions';
import * as SessionTypes from '../../../actions/session/types';

import DatePickerInput from '../../DatePickerInput/DatePickerInput';
import LoadingState from '../../LoadingState/index';
import { setLoggedIn } from '../../../lib/auth';

// Page styles
import cx from 'classnames';
import s from './VerifyDobForm.css';


export class VerifyDobForm extends Component {
  static propTypes = {
    loading: object,
    location: object,
    history: object,
    match: object,
    verifyDob: func,
  };

  constructor(props) {
    super(props);

    this.state = {
      dob: '',
      errorMessage: '',
    };
  }

  clearErrorMessage = () => {
    if (this.state.errorMessage) this.setState({ errorMessage: '' });
  };

  isValidDob = (date) => date;

  isLoading = (loading) => contains(SessionTypes.VERIFY_DOB_REQUEST, loading.requests);

  handleDobChange = (date) => this.setState({ dob: date });

  handleSubmit = () => {
    if (this.isValidDob(this.state.dob)) {
      this.clearErrorMessage();

      const successCallback = response => {
        const route = response.route;
        setLoggedIn(route, response.logoutUrl);

        /**
         * Successful responses return a route (home, resetpassword, etc.) indicating
         * where to transition the end user to based on a calculated session state
         * from the server side.
         */
        this.props.router.replace(`/${route}`);
      };

      const errorCallback = response => this.setState({ errorMessage: response.message.body });

      this.props.verifyDob(this.state.dob, successCallback, errorCallback);
    }
  };

  render = () => {
    const isLoading = this.isLoading(this.props.loading);
    const isValidDob = this.isValidDob(this.state.dob);

    return (
      <form
        className={s.component}
        id="verifyDobForm"
      >
        <h3 className={cx(s.header, s.verticalSpacing)}>
          Verify Your Account
        </h3>
        <label className={cx(s.secondaryText, s.verticalSpacing)} htmlFor="verifyAccountMessage">
          Please enter your date of birth.
        </label>
        <DatePickerInput
          className={s.verticalSpacing}
          id="verify_dob__date_picker"
          hasInputBorder
          maxDate={moment().format('YYYY-MM-DD')}
          onChange={this.handleDobChange}
          value={this.state.dob}
        />
        <button
          className={cx(s.btn, s.verticalSpacing)}
          id="submitVerifyDob"
          disabled={!isValidDob || isLoading}
          onClick={this.handleSubmit}
          type="button"
        >
          {isLoading ?
            <LoadingState context="verifyDobForm"/> :
            'Verify'
          }
        </button>
        <Link
          className={cx(s.link, s.verticalSpacing)}
          id="cancelVerifyDob"
          title="Cancel"
          to={`/login`}
        >
          Cancel
        </Link>
        {this.state.errorMessage &&
        <p className={cx(s.message, s.verticalSpacing)}>
          {this.state.errorMessage}
        </p>
        }
      </form>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.loadingState,
});

const mapDispatchToProps = dispatch => ({
  verifyDob: (dob, successCb, errorCb) => dispatch(verifyDob(dob, successCb, errorCb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VerifyDobForm));



// WEBPACK FOOTER //
// ./src/components/Pages/VerifyDob/VerifyDobForm.js